import { useMemo } from 'react';
import { GLPeriods } from 'src/services/useGLPeriodApi';
import { InvoiceBudgetPeriodResponse } from '../InvoiceDetailsContext';

const usePeriodStatusErrors = (
  invoiceBudgetPeriods: InvoiceBudgetPeriodResponse[],
  glPeriods: GLPeriods
) => {
  const periodClosedErrors = useMemo(() => {
    const invoiceBudgetPeriodWithClosePeriod = glPeriods.filter((p) =>
      invoiceBudgetPeriods.some((c) => c.glPeriodId === p.glPeriodId)
    );

    if (invoiceBudgetPeriodWithClosePeriod.some((per) => per.isClosed === 1)) {
      return ['Document includes a closed period.'];
    }

    return [];
  }, [glPeriods, invoiceBudgetPeriods]);

  return { periodClosedErrors };
};

export default usePeriodStatusErrors;
